module.exports = __webpack_public_path__ + "img/apple-touch-icon.33b71eba.png";